<div style="background: #fafafa">
	<div fxLayout="column" fxFill>
		<div fxFlex="85">
			<mat-sidenav-container>
				<mat-sidenav-content>
					<div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="30px" fxLayoutGap.lt-md="50px" class="container">
						<div fxFlex="50" fxFlex.lt-md="grow" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start" fxLayoutAlign.lt-md="start stretch">
							<img fxHide.lt-md class="image-desktop" src="assets/images/bannerdesktop.svg" style="height: 85vh">
							<img fxHide fxShow.lt-md src="assets/images/bannermovil.svg">
						</div>
						<div fxFlex="50" fxFlex.lt-md="grow" fxLayout="column" fxLayoutAlign="center stretch" id="intro-text" fxLayoutGap="30px">
							<div fxFlex="grow">
								<h2>¡Bienvenido!</h2>
								<p>
									Esta es una <strong>herramienta de autodiagnóstico en economía circular para empresas</strong>,
									pretende encontrar el potencial de mejora de su organización en la transición de un comportamiento
									lineal a una economía circular.
								</p>
								<p>
									Vivimos en un planeta finito con una población creciente y estándares de vida que mejoran
									constantemente. Para crear un futuro sostenible, debemos repensar cómo usamos nuestros recursos
									de una forma en la que los ciclos productivos estén pensados para que los insumos sean aprovechados
									en su totalidad, los recursos se reutilicen y no haya un efecto dañino al medio ambiente.
								</p>
								<p>
									La herramienta se compone de 3 módulos de preguntas:
								</p>
								<ol type="A">
									<li>
										Ciclo Productivo.
									</li>
									<li>
										Materiales y Servicios Auxiliares.
									</li>
									<li>
										Gestión interna y ecosistema de la economía circular.
									</li>
								</ol>
								<p>
									Los resultados serán descargables y enviados a tu correo electrónico de registro.
								</p>
								<p>
									Tiempo estimado de duración <strong> 15 min</strong>
								</p>
								<p>
									Recuerda: no existen respuestas correctas o incorrectas, es una autoevaluación.
								</p>
							</div>
							<div fxFlexAlign="center">
								<button mat-raised-button color="accent" routerLink="/user" >
									Comenzar
								</button>
							</div>
							<app-footer fxFlex.lt-md="grow" fxHide fxShow.lt-md></app-footer>
						</div>

					</div>
				</mat-sidenav-content>
			</mat-sidenav-container>
		</div>
		<div fxFlex="15" fxHide.lt-md>
			<app-footer></app-footer>
		</div>
	</div>
</div>




